<div class="flex w-full items-center gap-3">
  <div class="min-w-0 flex-1">
    <div
      class="relative w-full"
      [ngClass]="{
        'max-w-3xs min-w-64': appearance() === 'default',
        'max-w-none min-w-0': appearance() !== 'default',
      }">
      <span
        class="material-symbols-rounded absolute top-1/2 left-2.5 -translate-y-1/2 leading-none"
        [class.text-lg!]="appearance() !== 'comfortable'"
        [class.text-xl!]="appearance() === 'comfortable'"
        >search</span
      >
      <input
        #searchInput
        [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
        id="search-filter"
        type="text"
        class="border-standard-outline-light border-input focus:border-input-focus w-full resize bg-transparent focus:ring-0"
        [ngClass]="{
          'rounded-input p-input text-md h-10 pr-10 pl-9':
            appearance() === 'default',
          'h-8 rounded-md py-1 pr-9 pl-8 text-sm': appearance() === 'compact',
          'h-10 rounded-md py-2 pr-10 pl-10 text-base':
            appearance() === 'comfortable',
        }"
        [placeholder]="placeholder()"
        [value]="value"
        [disabled]="isDisabled"
        (input)="onInput($any($event.target).value)"
        (blur)="onBlur()" />
      @if (value && !isDisabled) {
        <button
          type="button"
          aria-label="Suche löschen"
          title="Suche löschen"
          data-testid="search-filter-clear"
          class="text-input-label hover:bg-standard-hover-main absolute top-1/2 right-1 flex -translate-y-1/2 cursor-pointer items-center justify-center rounded-sm"
          [ngClass]="{
            'h-6 w-6': appearance() === 'compact',
            'h-8 w-8': appearance() !== 'compact',
          }"
          (click)="onClear(); searchInput.focus()">
          <span class="material-symbols-rounded text-xl" aria-hidden="true"
            >close</span
          >
        </button>
      }
    </div>
  </div>

  <ng-container *ngTemplateOutlet="quickFilterTemplate() ?? null" />

  @if (quickFilterTemplate() && hasFilter()) {
    <div class="border-standard-divider self-stretch border-l"></div>
  }

  @if (hasFilter()) {
    <div class="relative">
      <button
        type="button"
        class="hover:bg-standard-hover-main flex cursor-pointer items-center gap-1 rounded-md px-2 py-1 text-sm"
        (click)="isFilterOpen.set(!isFilterOpen())">
        <span class="material-symbols-rounded pr-2">filter_alt</span>
        Filtern
        @if (activeFilterCount()) {
          <span
            class="bg-error-main absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-semibold text-white">
            {{ activeFilterCount() }}
          </span>
        }
      </button>

      @if (isFilterOpen()) {
        <div
          awCloseOnOffClick
          (onOffClick)="isFilterOpen.set(false)"
          class="border-standard-outline-light absolute top-full right-0 z-10 mt-2 flex flex-col gap-3 rounded-md border-1 bg-white p-3">
          <ng-content />
        </div>
      }
    </div>
  }
</div>
